import React, { createContext, useContext, useState, useEffect } from 'react'
import { domoscioAccess } from '../../api/domoscio_access'
import { reviewsFormater, TReviewFormated } from './utils'
import { useScormUser } from '../../hooks/useScormUser'
import { StudentReminders, TLoading } from '../../types/global'
import { reportToSentry } from '../../components/Errors/reporting'
import { useRiseUpClient } from '../../hooks/useRiseUpClient'
import I18n from '../../locales/I18n'

interface ReviewsContextType {
  reviews: TReviewFormated
  status: TLoading
  fetchReviews: () => void
}

const defaultReviewState = {
  ongoingChallenges: [], // accepted challenges
  pendingReviews: [], // reviews to do today
  allReviews: []
} as TReviewFormated

export type TApiParams = {
  student_uid: string
  group_by: string[]
  learning_program_id?: number
  objective_id?: Array<number>
}

const ReviewsContext = createContext<ReviewsContextType | undefined>(undefined)

export const ReviewsProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [reviews, setReviews] = useState<TReviewFormated>(defaultReviewState)
  const [status, setStatus] = useState<TLoading>('idle')
  const { isRiseup } = useRiseUpClient()

  const scopedList = useScormUser()

  const body = {
    ...scopedList,
    lang: I18n.locale
  } as { learning_program_id: number; lang?: string }

  if (!isRiseup) {
    delete body.lang
  }

  const fetchReviews = () => {
    setStatus('loading')
    domoscioAccess.getNextReviews(body).then((reviewList: StudentReminders[]) => {
      if (Array.isArray(reviewList)) {
        setReviews(reviewsFormater(reviewList))
        setStatus('success')
      } else {
        reportToSentry({
          name: 'Fetch Error',
          description: 'Failed to fetch reviews'
        })
        setStatus('error')
      }
    })
  }

  useEffect(() => {
    fetchReviews()
    // eslint-disable-next-line
  }, [])

  return (
    <ReviewsContext.Provider value={{ reviews, status, fetchReviews }}>
      {children}
    </ReviewsContext.Provider>
  )
}

export const useHomeReviews = () => {
  const context = useContext(ReviewsContext)
  if (!context) {
    throw new Error('useReviews must be used within a ReviewsProvider')
  }
  return context
}
